import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import Slider from 'react-slick'
import { Link } from 'react-router-dom'
import { UI, ROUTE } from '../config'

import '../styles/VehicleYearSelector.scss'

export default class VehicleYearSelector extends Component {

  static propTypes = {
    currentYear: PropTypes.string.isRequired,
    years: PropTypes.array.isRequired,
    onSelected: PropTypes.func.isRequired,
    slider: PropTypes.bool,
    baseRoute: PropTypes.string.isRequired,
    variant: PropTypes.oneOf(['default', 'unified']),
    directYearLinks: PropTypes.bool,
    preventNavigation: PropTypes.bool,
  }

  static defaultProps = {
    variant: 'default',
    directYearLinks: false,
    preventNavigation: false,
  }

  onYearBtnClick(e) {
    if (this.props.preventNavigation) {
      e.preventDefault()
    }
    const clickedYear = e.target.dataset.year
    if (this.props.currentYear !== clickedYear) {
      this.props.onSelected(clickedYear)
    }
  }

  componentDidMount() {
    if (this.props.slider)
      setTimeout(() => {
        if (this.props.currentYear && this.slider) {
          let index = this.props.years.indexOf(this.props.currentYear)

          //slide to current year if there are more than 2 others before it
          index = index > 2 ? index - 2 : 0

          this.slider.slickGoTo(index)
        }
      })
  }

  componentDidUpdate(prevProps) {
    if (this.props.slider && this.props.currentYear !== prevProps.currentYear) {
      setTimeout(() => {
        if (this.props.currentYear && this.slider) {
          let index = this.props.years.indexOf(this.props.currentYear)

          //slide to current year if there are more than 2 others before it
          index = index > 2 ? index - 2 : 0

          this.slider.slickGoTo(index)
        }
      })
    }
  }

  render() {
    const { baseRoute, currentYear, years, variant } = this.props
    const selectorClassName = classNames(
      'VehicleYearSelector',
      variant === 'unified' && 'VehicleYearSelector--unified',
      variant === 'unified' && this.props.slider && 'VehicleYearSelector--slider',
    )

    const buttons = []
    for (let i = 0; i < years.length; i++) {

      const yearLink = this.props.preventNavigation
        ? '#'
        : this.props.directYearLinks
          ? `${baseRoute}/${years[i]}`
          : `${baseRoute}${ROUTE.VEHICLES}/${years[i]}/`

      buttons.push(
        <div className={classNames('wrapper', years[i] === currentYear && 'wrapper--current')} key={i}>
          <Link
            to={yearLink}
            {...years[i] === currentYear ? {className: 'current'} : {}}
            data-year={years[i]}
            onClick={this.onYearBtnClick.bind(this)}>
            {years[i]}
          </Link>
        </div>
      )
    }

    if (this.props.slider) {
      return (
        <div className={selectorClassName}>
          <Slider ref={(c) => { this.slider = c }} {...{
            className: 'center',
            dots: false,
            arrows: false,
            infinite: false,
            swipeToSlide: true,
            variableWidth: true,
            speed: UI.ANIMATION_DELAY,
            /*afterChange: (index) => {
             get current slide index
             },*/
          }}>
            {buttons}
          </Slider>
        </div>
      )
    } else {
      return (
        <div className={selectorClassName}>
          <div className="nav-inner">
            {buttons}
          </div>
        </div>
      )
    }

  }
}
